<template>
  <ul class="role-navigation">
    <RoleNavigationItem
      v-for="item in items"
      :key="item.id"
      :item="item"
      :active-item-id="activeItemId"
      :open-group-ids="openGroupIds"
      @toggle-group="toggleGroup"
    />
  </ul>
</template>

<script>
import { findActiveItemId } from '@/navigation/findActiveItemId';
import RoleNavigationItem from './RoleNavigationItem';

function groupIdsContaining(items, itemId) {
  for (const item of items) {
    if (item.id === itemId) {
      return [];
    }
    const pathBelow = groupIdsContaining(item.children, itemId);
    if (pathBelow !== null) {
      return [item.id, ...pathBelow];
    }
  }
  return null;
}

/**
 * New sidebar navigation from `myAccess` (admin preview). Active entry from the router;
 * several groups may be open; the group of the active entry is opened, never closed here.
 */
export default {
  name: 'RoleNavigation',
  components: { RoleNavigationItem },
  props: {
    items: { type: Array, required: true },
  },
  data() {
    return {
      openGroupIds: [],
    };
  },
  computed: {
    activeItemId() {
      return findActiveItemId(this.items, this.$route.path);
    },
  },
  watch: {
    activeItemId: {
      immediate: true,
      handler(activeItemId) {
        const activeGroupIds = groupIdsContaining(this.items, activeItemId) || [];
        const newGroupIds = activeGroupIds.filter(
          (groupId) => !this.openGroupIds.includes(groupId)
        );
        this.openGroupIds = [...this.openGroupIds, ...newGroupIds];
      },
    },
  },
  methods: {
    toggleGroup(groupId) {
      const isOpen = this.openGroupIds.includes(groupId);
      this.openGroupIds = isOpen
        ? this.openGroupIds.filter((openGroupId) => openGroupId !== groupId)
        : [...this.openGroupIds, groupId];
    },
  },
};
</script>

<style lang="scss" scoped>
.role-navigation {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
